import { Component } from '@angular/core';
import { EditBlockBase } from '../../edit-block-base';
import { DurationControlComponent } from "../../../common/components/duration-control/duration-control";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'session-rest-edit',
  providers: [],
  standalone: true,
  styleUrls: ['./../component-edit.scss'],
  imports: [
    DurationControlComponent,
    TranslateModule
  ],
  templateUrl: './session-rest-edit.html'
})
export class SessionRestEditComponent extends EditBlockBase {
    public onRestTimeChange(): void {
        this.baseComponent.onTimeBasedInfoUpdated.emit();
        this.baseComponent.onChanged.emit();
    }
}
